
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { SnackbarCloseReason } from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";

import { UP_LOGO } from "../../app/constants/constants";
import { CloseIcon } from "../../iconRef/recipePageIcons"
import styles from "./installApp.module.css";
import { InstallAppContentProps } from "./InstallPrompt.types";

const InstallAppContent = ({ setIsOpen, handleInstallClick, setInstallBannerToSessionStorage }: InstallAppContentProps) => {
    const handleClose = (_: any, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return;
        }

        setIsOpen(false);
        setInstallBannerToSessionStorage(true)
    };
    return (
        <Grid alignItems="center" container direction="row"
            id="InstallAppContent" xs={12}>
            <Grid alignItems="center" container spacing={1}
                xs={9} >
                <Grid id="InstallAppContentcloseIconButton" item  >
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleClose}
                        size="small"
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Grid>
                <Grid id="InstallAppContentLogo" item >

                    <img alt="upliance.ai icon"
                        className={styles.img}
                        src={UP_LOGO}
                    />
                </Grid>
                <Grid id="InstallAppContentTypography" item   >
                    <Typography variant="ingredientText2mini">upliance.ai</Typography>
                </Grid>
            </Grid>
            <Grid container id="InstallAppContentButton" item
                xs={3}>
                <Button color="secondary" onClick={handleInstallClick} size="small"
                    variant="outlined">
                    <Typography variant="ingredientText2paralell">GET APP</Typography>
                </Button>
            </Grid>
        </Grid>)
}

export default InstallAppContent
